export default "/assets/images/badge-03.5b05b0a3879a7079.webp";